type Listener<T> = (data: T) => void;

export class Listenable<T>
{
    private listeners: Listener<T>[] = [];

    listen(listener: Listener<T>)
    {
        this.listeners.push(listener);
    }

    call(value: T)
    {
        for (let listener of this.listeners)
        {
            listener(value);
        }
    }
}